 <!-- ----------------------------------------------------------------------- -->
    <!--                             nav Section                              -->
    <!-- ----------------------------------------------------------------------- -->
    
    <nav class="row nav mx-auto col-8 col-md-7 col-lg-6 justify-content-between">
        <div class="col-6 nav-logo">
            <figure class="nav-logo__container"><a [routerLink]="['/home']"><img class="nav-logo__container-img img-fluid" src="web-assets/images/Noor-logo-01.svg"></a></figure>
        </div>
        <div class="col-6 p-0 nav-auth row">
            <div class="col-6  nav-auth__name text-center">{{currentUser.name}}</div>
            <div class=" nav-auth__stat cursor-pointer " (click)="logout();"><a >Sign out</a></div>
        </div>
    </nav>